import { render, staticRenderFns } from "./search-page.vue?vue&type=template&id=5d662a9e&"
import script from "./search-page.vue?vue&type=script&lang=js&"
export * from "./search-page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports